import { api } from './base';

export interface ParentDepartment {
  id: number;
  name: string;
}

export interface Department {
  id: number;
  name: string;
  leader_id?: number;
  parent_id?: number;
  level: number;
  is_leaf: boolean;
  dingtalk_id?: string;
  description?: string;
  create_time?: string;
  modify_time?: string;
  parent?: ParentDepartment;
  sites?: Array<string>;
  site_access: boolean;
}

export const departmentApis = {
  async search(name: string, external?: boolean): Promise<Array<Department>> {
    let url = `/departments?limit=1000&name=${name}`;
    if (external != undefined) {
      url += `&external=${external}`;
    }
    const result = await api.get(url);
    return result.departments;
  },
  myDepartments(): Promise<Array<Department>> {
    return api.get(`/my_departments`).then(r => r.departments);
  }
};
